// All bookings route to Karen's Jane App profile.
export const JANE_BOOK = "https://wavescollective.janeapp.com/#/staff_member/9";
// Free 20-minute consultation treatment link.
export const JANE_CONSULT = "https://wavescollective.janeapp.com/#/staff_member/9/treatment/217";

// Standard props for any outbound link (opens in a new tab).
export const external = {
  target: "_blank",
  rel: "noopener noreferrer",
};
